export default __webpack_public_path__ + "static/media/user.9b679b59.svg";